/**
 * Validate form inputs
 * @param {HTMLElement} input
 * @param {function} callback
 */
export const validateInput = (input, callback) => {
  const { validity } = input;

  // Skip if this is not a real input
  if (!validity) {
    return undefined;
  }

  // Is required and has no value
  if (validity.valueMissing) {
    return "Required";
  }

  if (validity.patternMismatch) {
    switch (input.type) {
      case "email":
        return "Enter a valid email address";
      case "tel":
        return "Enter a valid phone number";
      default:
        switch (input.id) {
          case "customPrice":
          case "loanAmount":
            return "Enter a valid dollar amount";
          case "zip":
            return "Enter a valid ZIP code";
          default:
            return "Enter a valid format";
        }
    }
  }

  if (
    validity.tooShort ||
    (!!input.minLength && input.value.length < input.minLength)
  ) {
    switch (input.type) {
      case "password":
        return "Enter a longer password";
      default:
        return "Enter a longer value";
    }
  }
};

/**
 * Validation patterns
 */
export const validationPatterns = {
  dollar: "^\\$?(([1-9]\\d{0,2}(,\\d{3})*)|\\d+)?(\\.\\d{2})?$",
  email: "[^\\s@]+@[^\\s@]+\\.[^\\s@]+",
  tel: "\\(?[0-9]{3}\\)?[ \\-\\.]?[0-9]{3}[\\-\\.]?[0-9]{4}([,x]\\d*)?",
  zip: "^\\d{5}(?:[\\- ]\\d{4})?$",
};
